import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import Image from "../../overrides/venia-ui/components/Image";
import Icon from "../Icon";
import defaultClasses from "./pickupPoint.module.scss";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import image from "../../assets/images/pickup-point.png";
import { Link } from "../../drivers";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { useIntl } from "react-intl";
import { distance } from "@Src_main/utils/generalUtils";
import { getStoreStatus } from "@Src_main/utils/storeHoursUtils";
import Modal from "@Components/Modal";
import StoreDetails from "@Components/StoreDetails";
import { useGmbOpeningHours } from "@Src_main/utils/useGmbOpeningHours";
import { formatTime } from "@Src_main/utils/gmbOpeningHoursUtils";
export function formatDistance(distance) {
  if (distance < 1000) return distance.toFixed(0) + "m";else return (distance / 1000).toFixed(2) + "km";
}
const PickupPoint = _ref => {
  let {
    selectable,
    onSelect,
    store,
    choosedPosition,
    showStoreHours,
    classes: propsClasses,
    showDetailModal = false
  } = _ref;
  const {
    formatMessage
  } = useIntl();
  const classes = mergeClasses(defaultClasses, propsClasses);
  const linkUrl = formatMessage({
    id: "url.key.restaurants"
  }) + "/".concat(store.url_key);
  const title = store.frontend_name ? store.frontend_name : store.name;
  const address = store.address.address1;
  const distanceCalculated = choosedPosition ? distance(choosedPosition.latitude, choosedPosition.longitude, store.latitude, store.longitude) : null;
  const [isModalStoreDetailsOpen, setIsModalStoreDetailsOpen] = useState(false);
  const {
    isMobile
  } = useWindowSize();
  const store_preview_image_mobile = store.store_preview_image_mobile;
  const store_preview_image_desktop = store.store_preview_image_desktop;
  const store_preview_image = isMobile ? store_preview_image_mobile : store_preview_image_desktop;
  const storePreviewImage = store_preview_image ? store_preview_image : image;

  // Get GMB status (with today/tomorrow hours already computed)
  const gmbLocationId = (store === null || store === void 0 ? void 0 : store.gmbLocationId) || null;
  const {
    storeStatus: gmbStoreStatus,
    loading: gmbLoading,
    hasGmbData
  } = useGmbOpeningHours(gmbLocationId);

  // Get regular store status as fallback
  const regularStoreStatus = getStoreStatus(store.store_hours);

  // Helper function to format hours for display
  const formatHoursForDisplay = effectiveHours => {
    if (!effectiveHours || effectiveHours.type === 'closed') {
      return formatMessage({
        id: "storeHours.closed"
      });
    }
    if (effectiveHours.periods && effectiveHours.periods.length > 0) {
      return effectiveHours.periods.map(p => "".concat(formatTime(p.openTime), "-").concat(formatTime(p.closeTime))).join(" / ");
    }
    return formatMessage({
      id: "storeHours.closed"
    });
  };

  // Determine display values based on GMB or regular hours
  let isOpen, todayDisplay, tomorrowDisplay;
  if (hasGmbData && gmbStoreStatus) {
    // Use GMB data
    isOpen = gmbStoreStatus.isOpen;
    todayDisplay = formatHoursForDisplay(gmbStoreStatus.todayHours);
    tomorrowDisplay = formatHoursForDisplay(gmbStoreStatus.tomorrowHours);
  } else if (regularStoreStatus) {
    // Fallback to regular store status
    isOpen = regularStoreStatus.isOpen;
    todayDisplay = regularStoreStatus.todayHours && regularStoreStatus.todayHours.length > 0 ? regularStoreStatus.todayHours.map(x => "".concat(x.open || '', "-").concat(x.close || '')).join(" / ") : formatMessage({
      id: "storeHours.closed"
    });
    tomorrowDisplay = regularStoreStatus.tomorrowHours && regularStoreStatus.tomorrowHours.length > 0 ? regularStoreStatus.tomorrowHours.map(x => "".concat(x.open || '', "-").concat(x.close || '')).join(" / ") : formatMessage({
      id: "storeHours.closed"
    });
  } else {
    // Ultimate fallback if no status available
    isOpen = false;
    todayDisplay = formatMessage({
      id: "storeHours.closed"
    });
    tomorrowDisplay = formatMessage({
      id: "storeHours.closed"
    });
  }

  // Show spinner while loading GMB data (only if store has a GMB location ID)
  const isLoadingGmbHours = gmbLoading && gmbLocationId;
  const storeHours = /*#__PURE__*/React.createElement("div", {
    className: "uk-text-dimgray store-hours ".concat(classes.hours)
  }, isLoadingGmbHours ? /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-center uk-flex-middle",
    style: {
      minHeight: '50px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    "uk-spinner": "ratio: 0.6"
  })) : /*#__PURE__*/React.createElement("div", {
    className: "restaurant-hours uk-text-xsmall uk-flex uk-flex-column ".concat(classes.restaurant),
    style: {
      animation: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-row uk-flex-left uk-flex-middle uk-text-bold  ".concat(isOpen ? "uk-text-success-alt" : "uk-text-emphasis"),
    style: {
      animation: 'none'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-shipping",
    style: {
      animation: 'none'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "days uk-padding-small uk-padding-remove-vertical uk-padding-remove-right ".concat(classes.days)
  }), /*#__PURE__*/React.createElement("div", {
    className: "time ".concat(classes.time)
  }), /*#__PURE__*/React.createElement("div", null, isOpen ? formatMessage({
    id: "storeHours.openNow"
  }) : formatMessage({
    id: "storeHours.closedNow"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, formatMessage({
    id: "storeHours.today"
  }), ": ", todayDisplay), /*#__PURE__*/React.createElement("div", null, formatMessage({
    id: "storeHours.tomorrow"
  }), ": ", tomorrowDisplay))));
  const contentPickupPoint = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.ContentImage
  }, /*#__PURE__*/React.createElement(Image, {
    alt: "Miscusi",
    src: storePreviewImage,
    displayPlaceholder: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-column uk-flex-center uk-width-expand ".concat(classes.content)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.title, " uk-text-uppercase")
  }, title), showDetailModal ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.infoDot),
    onClick: e => {
      e.stopPropagation();
      setIsModalStoreDetailsOpen(true);
    }
  }, /*#__PURE__*/React.createElement("span", null, "i")) : null, address ? /*#__PURE__*/React.createElement("div", {
    className: classes.address
  }, store.address.address1) : null, /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-column ".concat(classes.info)
  }, distanceCalculated ? /*#__PURE__*/React.createElement("div", {
    className: "uk-flex ".concat(classes.distance)
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-locator",
    color: "black"
  }), /*#__PURE__*/React.createElement("div", null, formatDistance(distanceCalculated))) : null), showStoreHours ? storeHours : null));
  const onCloseDetails = e => {
    e.stopPropagation();
    setIsModalStoreDetailsOpen(false);
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "component-pickup-point uk-flex ".concat(classes.root, " ").concat(selectable ? classes.selectable : "")
  }, onSelect ? {
    onClick: onSelect
  } : {}), !onSelect ? /*#__PURE__*/React.createElement(Link, {
    className: "uk-flex uk-width",
    to: linkUrl
  }, contentPickupPoint) : contentPickupPoint, showDetailModal && isModalStoreDetailsOpen ? /*#__PURE__*/React.createElement(Modal, {
    id: store.ls_store_id,
    nameClass: "modal-store-details",
    isOpen: !!isModalStoreDetailsOpen,
    onClose: onCloseDetails,
    modalDialogClass: "uk-height-xlarge uk-padding-medium-top",
    canBeClosed: true,
    modalCloseOutside: true,
    position: "uk-position-bottom section-full-rounded"
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-overflow-auto"
  }, /*#__PURE__*/React.createElement(StoreDetails, {
    store: store,
    showCta: false
  }))) : null);
};
export default PickupPoint;